module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/common/ask-for-reload/ask-for-reload.component.css
// module id = ./src/app/common/ask-for-reload/ask-for-reload.component.css
// module chunks = main